module.exports = __webpack_public_path__ + "static/media/left-arrow.9cd4a377.svg";